/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanyCcnOfferQuery = gql`
  query GetSimulationCompanyCcnOfferQuery($ccn: String, $college: String, $ccnRef: String) {
    getSimulationCompanyCcnOffer_simulation_company(ccn: $ccn, college: $college, ccnRef: $ccnRef) {
      ccnOffer 
      ccnId 
      ccnRef 
      ccnName 
      redirection 
      oldCcnId 
      oldCcnName 
      comment 
    }
  }
`;

export default GetSimulationCompanyCcnOfferQuery;
